export default __webpack_public_path__ + "static/media/veh-13.def72047.png";